const WORKSPACES_ROOT_URL = `/data-studio/workspaces`;

export function workspaces() {
  return WORKSPACES_ROOT_URL;
}
